import { Step } from 'react-joyride';

export type DemoDashboardSection =
  | 'dashboard'
  | 'customer-management'
  | 'scheduling'
  | 'route-optimization';

export type DemoTourStep = Step & {
  /** Switch dashboard tab before this step highlights */
  section?: DemoDashboardSection;
};

export const DEMO_TOUR_STORAGE_KEY = 'lawnhub.demoTour.choice';
/** Fired from Command Center; also used with sessionStorage when not on Dashboard yet. */
export const DEMO_START_TOUR_EVENT = 'lawnhub:start-demo-tour';
export const DEMO_TOUR_AUTOSTART_KEY = 'lawnhub.demoTour.autoStart';

/** Phase 1 guided tour — Dashboard tabs: Customers, Scheduling, Routes. */
export const DEMO_PHASE1_TOUR_STEPS: DemoTourStep[] = [
  {
    target: '[data-tour="demo-tab-dashboard"]',
    content:
      'This is your home base. Today’s Jobs, This Week’s Schedule, and marketplace requests live here. We’ll walk the tabs that matter most for running a week.',
    section: 'dashboard',
    disableBeacon: true,
    placement: 'center',
  },
  {
    target: '[data-tour="demo-todays-jobs"]',
    content:
      'Today’s Jobs: complete or skip stops for the day. Incomplete stops get a banner so nothing falls through the cracks.',
    section: 'dashboard',
    placement: 'center',
  },
  {
    target: '[data-tour="demo-this-weeks-schedule"]',
    content:
      'This Week’s Schedule shows what’s already on each day from recurring services — the same idea after you onboard real customers.',
    section: 'dashboard',
    placement: 'center',
  },
  {
    target: '[data-tour="demo-tab-customers"]',
    content:
      'Customer Management is where you onboard existing customers (usually 1% fee) and keep properties, services, and invites in one place.',
    section: 'dashboard',
    placement: 'center',
  },
  {
    target: '[data-tour="demo-customers-import"]',
    content:
      'Import Current Customer: add one customer with address, services, price, and send an invite so they can set up payment.',
    section: 'customer-management',
    placement: 'center',
  },
  {
    target: '[data-tour="demo-customers-csv"]',
    content:
      'Import from CSV: bulk-load many customers, then set prices and send invitations.',
    section: 'customer-management',
    placement: 'center',
  },
  {
    target: '[data-tour="demo-customers-table"]',
    content:
      'Your customer list: open a row for details, services, next dates, and actions. Sample Demo Township customers are already here.',
    section: 'customer-management',
    placement: 'center',
  },
  {
    target: '[data-tour="demo-tab-scheduling"]',
    content:
      'Scheduling tools put work on the calendar: Add to Today, Move Day, Add All, and Edit Schedules.',
    section: 'customer-management',
    placement: 'center',
  },
  {
    target: '[data-tour="demo-sched-add-today"]',
    content:
      'Add to Today: pull accepted / unscheduled work onto today’s list.',
    section: 'scheduling',
    placement: 'center',
  },
  {
    target: '[data-tour="demo-sched-move-day"]',
    content:
      'Move Day: slide everything from one date to another (great for weather). Recurring weekday usually stays unless you make a permanent change elsewhere.',
    section: 'scheduling',
    placement: 'center',
  },
  {
    target: '[data-tour="demo-sched-add-all"]',
    content:
      'Add All: dump a whole service type onto a date (storm / catch-up day).',
    section: 'scheduling',
    placement: 'center',
  },
  {
    target: '[data-tour="demo-sched-edit"]',
    content:
      'Edit Schedules: change next dates or recurring patterns per customer.',
    section: 'scheduling',
    placement: 'center',
  },
  {
    target: '[data-tour="demo-tab-routes"]',
    content:
      'Route Optimization turns a day’s stops into crew drive order — Sort and Optimize, tweak, then Save Routes for the crew app.',
    section: 'scheduling',
    placement: 'center',
  },
  {
    target: '[data-tour="demo-routes-date"]',
    content:
      'Pick the date you’re building. Sunday habit: do Mon–Sat once so crews have saved routes all week.',
    section: 'route-optimization',
    placement: 'center',
  },
  {
    target: '[data-tour="demo-routes-sort"]',
    content:
      'Sort and Optimize: assigns today’s stops to crews by service type, then optimizes drive order.',
    section: 'route-optimization',
    placement: 'center',
  },
  {
    target: '[data-tour="demo-routes-reoptimize"]',
    content:
      'Re-optimize: after you drag stops between crews, reorder drive sequence without re-sorting assignments.',
    section: 'route-optimization',
    placement: 'center',
  },
  {
    target: '[data-tour="demo-routes-save"]',
    content:
      'Save Routes: lock the day for crew logins. Change the date and repeat for the rest of the week.',
    section: 'route-optimization',
    placement: 'center',
  },
  {
    target: '[data-tour="demo-tab-dashboard"]',
    content:
      'You’re set for Phase 1. Explore freely — use Reset demo data in the yellow banner anytime. Restart this tour anytime from Guided Tour under Tutorials in Command Center. When finished, use Log Out of Demo at the top so the sandbox resets for the next person.',
    section: 'dashboard',
    placement: 'center',
  },
];
